<template>
  <template v-if="mode=='cascader'">
    <div :class="classes">
      <cascader
        :data="data"
        :value.sync="value"
        :disabled="disabled"
        :clearable="clearable"
        :placeholder="placeholder"
        :size="size"
        :change-on-select="changeOnSelect"
        :render-format="renderFormat"
        :not-found-text="notFoundText"
      ></cascader>
      <div
        :class="[`${formPrefixCls}-error-msg-tip`]"
        v-if="validateMessage && showMessage"
      >{{ validateMessage }}</div>
    </div>
  </template>
  <template v-if="mode=='text'">
    <span>{{str}}</span>
  </template>
</template>
<script>
import cascader from "../../standard/components/cascader";
import { getJSON } from "../../common/utils/utils";
import { oneOf, PRE } from "../../common/utils/assist";
const prefixCls = `${PRE}-select`;
const formPrefixCls = `${PRE}-form-item`;
function findssx(item, result, valueAry, index) {
  index = index || 0;
  var tmp = [];
  item.forEach(child => {
    if (child.value == valueAry[index]) {
      result.push(child.label);
      if (valueAry[index + 1] && child.children.length) {
        findssx(child.children, result, valueAry, index + 1);
      }
    }
  });
}
export default {
  components: {
    cascader
  },
  props: {
    mode: {
      validator(value) {
        return oneOf(value, ["cascader", "text"]);
      },
      default: "cascader"
    },
    value: {
      coerce: function(val) {
        if (typeof val == "string" && val.indexOf(",") != -1) {
          return val.split(",");
        } else {
          return val;
        }
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: ""
    },
    size: {
      validator(value) {
        return oneOf(value, ["small", "large"]);
      }
    },
    trigger: {
      validator(value) {
        return oneOf(value, ["click", "hover"]);
      },
      default: "click"
    },
    changeOnSelect: {
      type: Boolean,
      default: false
    },
    renderFormat: {
      type: Function,
      default(label) {
        return label.join(" / ");
      }
    },

    notFoundText: {
      type: String
    }
  },
  data() {
    return {
      data: [],
      labels: [],
      str: "",
      validateState: "",
      PRE: PRE,
      prefixCls: prefixCls,
      formPrefixCls: formPrefixCls
    };
  },

  compiled() {
    if (!sessionStorage.getItem("provinces")) {
      this.jsonp({
        url: "//static.360buyimg.com/pops/xstoreom/area/area.js",
        callback: "callback",
        data: {},
        success: function(d) {
          this.data = d;
          if (this.mode == "text") {
            findssx(this.data, this.labels, this.value, 0);
            this.str = this.renderFormat(this.labels);
          }
        }.bind(this)
      });
    } else {
      this.data = JSON.parse(sessionStorage.getItem("provinces"));
      if (this.mode == "text") {
        findssx(this.data, this.labels, this.value, 0);
        this.str = this.renderFormat(this.labels);
      }
    }
  },
  computed: {
    classes() {
      return [
        `${prefixCls}`,
        `${prefixCls}-xcascader`,
        {
          [`${PRE}-form-item-error`]: this.validateState == "error",
        }
      ];
    }
  },
  methods: {
    jsonp: function(options) {
      options = options || {};
      options.time = options.time || 5000;
      if (!options.url || !options.callback) {
        throw new Error("参数不合法");
      }

      //创建 script 标签并加入到页面中
      var callbackName = "jd_popx_area";
      var oHead = document.getElementsByTagName("head")[0];
      options.data[options.callback] = callbackName;
      var params = this.formatParams(options.data);
      var oS = document.createElement("script");
      oS.setAttribute("id", "jd_popx_area");
      if (!document.querySelector("#jd_popx_area")) {
        oHead.appendChild(oS);
        //创建jsonp回调函数
        window[callbackName] = json => {
          oHead.removeChild(oS);
          clearTimeout(oS.timer);
          window[callbackName] = null;
          options.success && options.success(json);
          sessionStorage.setItem("provinces", JSON.stringify(json));
        };

        //发送请求
        oS.src = options.url + "?" + params;

        //超时处理
        if (options.time) {
          oS.timer = setTimeout(function() {
            window[callbackName] = null;
            oHead.removeChild(oS);
            options.fail &&
              options.fail({
                message: "超时"
              });
          }, options.time);
        }
      } else {
        var t = window.setInterval(function() {
          if (sessionStorage.getItem("provinces")) {
            options.success(JSON.parse(sessionStorage.getItem("provinces")));
            clearInterval(t);
          }
        }, 100);
      }
    },
    formatParams: function(data) {
      var arr = [];
      for (var name in data) {
        arr.push(
          encodeURIComponent(name) + "=" + encodeURIComponent(data[name])
        );
      }
      return arr.join("&");
    }
  }
};
</script>


// WEBPACK FOOTER //
// xcascader.vue?3cff37f7